import React from 'react';

// Components
import Bread from '../components/Bread';
import ServiceComponent from '../components/Service';

const Service = () => {
  return (<>
      <Bread title="Our Services" des="We are team of talanted designers making Web and Native Apps" />
      <ServiceComponent/>
  </>);
}

export default Service;
